/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth.index'
import { Route as AuthTagsRouteImport } from './routes/_auth.tags'
import { Route as AuthSessionsRouteImport } from './routes/_auth.sessions'
import { Route as AuthPhotosRouteImport } from './routes/_auth.photos'
import { Route as AuthDeliveriesRouteImport } from './routes/_auth.deliveries'
import { Route as AuthTagsSlugRouteImport } from './routes/_auth.tags.$slug'
import { Route as AuthSessionsNewRouteImport } from './routes/_auth.sessions.new'
import { Route as AuthSessionsSlugRouteImport } from './routes/_auth.sessions.$slug'
import { Route as AuthPhotosNewRouteImport } from './routes/_auth.photos.new'
import { Route as AuthPhotosIdRouteImport } from './routes/_auth.photos.$id'
import { Route as AuthDeliveriesNewRouteImport } from './routes/_auth.deliveries.new'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTagsRoute = AuthTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSessionsRoute = AuthSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPhotosRoute = AuthPhotosRouteImport.update({
  id: '/photos',
  path: '/photos',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDeliveriesRoute = AuthDeliveriesRouteImport.update({
  id: '/deliveries',
  path: '/deliveries',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTagsSlugRoute = AuthTagsSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => AuthTagsRoute,
} as any)
const AuthSessionsNewRoute = AuthSessionsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthSessionsRoute,
} as any)
const AuthSessionsSlugRoute = AuthSessionsSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => AuthSessionsRoute,
} as any)
const AuthPhotosNewRoute = AuthPhotosNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthPhotosRoute,
} as any)
const AuthPhotosIdRoute = AuthPhotosIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthPhotosRoute,
} as any)
const AuthDeliveriesNewRoute = AuthDeliveriesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthDeliveriesRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/login': typeof LoginRoute
  '/deliveries': typeof AuthDeliveriesRouteWithChildren
  '/photos': typeof AuthPhotosRouteWithChildren
  '/sessions': typeof AuthSessionsRouteWithChildren
  '/tags': typeof AuthTagsRouteWithChildren
  '/deliveries/new': typeof AuthDeliveriesNewRoute
  '/photos/$id': typeof AuthPhotosIdRoute
  '/photos/new': typeof AuthPhotosNewRoute
  '/sessions/$slug': typeof AuthSessionsSlugRoute
  '/sessions/new': typeof AuthSessionsNewRoute
  '/tags/$slug': typeof AuthTagsSlugRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/deliveries': typeof AuthDeliveriesRouteWithChildren
  '/photos': typeof AuthPhotosRouteWithChildren
  '/sessions': typeof AuthSessionsRouteWithChildren
  '/tags': typeof AuthTagsRouteWithChildren
  '/': typeof AuthIndexRoute
  '/deliveries/new': typeof AuthDeliveriesNewRoute
  '/photos/$id': typeof AuthPhotosIdRoute
  '/photos/new': typeof AuthPhotosNewRoute
  '/sessions/$slug': typeof AuthSessionsSlugRoute
  '/sessions/new': typeof AuthSessionsNewRoute
  '/tags/$slug': typeof AuthTagsSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/deliveries': typeof AuthDeliveriesRouteWithChildren
  '/_auth/photos': typeof AuthPhotosRouteWithChildren
  '/_auth/sessions': typeof AuthSessionsRouteWithChildren
  '/_auth/tags': typeof AuthTagsRouteWithChildren
  '/_auth/': typeof AuthIndexRoute
  '/_auth/deliveries/new': typeof AuthDeliveriesNewRoute
  '/_auth/photos/$id': typeof AuthPhotosIdRoute
  '/_auth/photos/new': typeof AuthPhotosNewRoute
  '/_auth/sessions/$slug': typeof AuthSessionsSlugRoute
  '/_auth/sessions/new': typeof AuthSessionsNewRoute
  '/_auth/tags/$slug': typeof AuthTagsSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/deliveries'
    | '/photos'
    | '/sessions'
    | '/tags'
    | '/deliveries/new'
    | '/photos/$id'
    | '/photos/new'
    | '/sessions/$slug'
    | '/sessions/new'
    | '/tags/$slug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/deliveries'
    | '/photos'
    | '/sessions'
    | '/tags'
    | '/'
    | '/deliveries/new'
    | '/photos/$id'
    | '/photos/new'
    | '/sessions/$slug'
    | '/sessions/new'
    | '/tags/$slug'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/_auth/deliveries'
    | '/_auth/photos'
    | '/_auth/sessions'
    | '/_auth/tags'
    | '/_auth/'
    | '/_auth/deliveries/new'
    | '/_auth/photos/$id'
    | '/_auth/photos/new'
    | '/_auth/sessions/$slug'
    | '/_auth/sessions/new'
    | '/_auth/tags/$slug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tags': {
      id: '/_auth/tags'
      path: '/tags'
      fullPath: '/tags'
      preLoaderRoute: typeof AuthTagsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sessions': {
      id: '/_auth/sessions'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof AuthSessionsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/photos': {
      id: '/_auth/photos'
      path: '/photos'
      fullPath: '/photos'
      preLoaderRoute: typeof AuthPhotosRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/deliveries': {
      id: '/_auth/deliveries'
      path: '/deliveries'
      fullPath: '/deliveries'
      preLoaderRoute: typeof AuthDeliveriesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/tags/$slug': {
      id: '/_auth/tags/$slug'
      path: '/$slug'
      fullPath: '/tags/$slug'
      preLoaderRoute: typeof AuthTagsSlugRouteImport
      parentRoute: typeof AuthTagsRoute
    }
    '/_auth/sessions/new': {
      id: '/_auth/sessions/new'
      path: '/new'
      fullPath: '/sessions/new'
      preLoaderRoute: typeof AuthSessionsNewRouteImport
      parentRoute: typeof AuthSessionsRoute
    }
    '/_auth/sessions/$slug': {
      id: '/_auth/sessions/$slug'
      path: '/$slug'
      fullPath: '/sessions/$slug'
      preLoaderRoute: typeof AuthSessionsSlugRouteImport
      parentRoute: typeof AuthSessionsRoute
    }
    '/_auth/photos/new': {
      id: '/_auth/photos/new'
      path: '/new'
      fullPath: '/photos/new'
      preLoaderRoute: typeof AuthPhotosNewRouteImport
      parentRoute: typeof AuthPhotosRoute
    }
    '/_auth/photos/$id': {
      id: '/_auth/photos/$id'
      path: '/$id'
      fullPath: '/photos/$id'
      preLoaderRoute: typeof AuthPhotosIdRouteImport
      parentRoute: typeof AuthPhotosRoute
    }
    '/_auth/deliveries/new': {
      id: '/_auth/deliveries/new'
      path: '/new'
      fullPath: '/deliveries/new'
      preLoaderRoute: typeof AuthDeliveriesNewRouteImport
      parentRoute: typeof AuthDeliveriesRoute
    }
  }
}

interface AuthDeliveriesRouteChildren {
  AuthDeliveriesNewRoute: typeof AuthDeliveriesNewRoute
}

const AuthDeliveriesRouteChildren: AuthDeliveriesRouteChildren = {
  AuthDeliveriesNewRoute: AuthDeliveriesNewRoute,
}

const AuthDeliveriesRouteWithChildren = AuthDeliveriesRoute._addFileChildren(
  AuthDeliveriesRouteChildren,
)

interface AuthPhotosRouteChildren {
  AuthPhotosIdRoute: typeof AuthPhotosIdRoute
  AuthPhotosNewRoute: typeof AuthPhotosNewRoute
}

const AuthPhotosRouteChildren: AuthPhotosRouteChildren = {
  AuthPhotosIdRoute: AuthPhotosIdRoute,
  AuthPhotosNewRoute: AuthPhotosNewRoute,
}

const AuthPhotosRouteWithChildren = AuthPhotosRoute._addFileChildren(
  AuthPhotosRouteChildren,
)

interface AuthSessionsRouteChildren {
  AuthSessionsSlugRoute: typeof AuthSessionsSlugRoute
  AuthSessionsNewRoute: typeof AuthSessionsNewRoute
}

const AuthSessionsRouteChildren: AuthSessionsRouteChildren = {
  AuthSessionsSlugRoute: AuthSessionsSlugRoute,
  AuthSessionsNewRoute: AuthSessionsNewRoute,
}

const AuthSessionsRouteWithChildren = AuthSessionsRoute._addFileChildren(
  AuthSessionsRouteChildren,
)

interface AuthTagsRouteChildren {
  AuthTagsSlugRoute: typeof AuthTagsSlugRoute
}

const AuthTagsRouteChildren: AuthTagsRouteChildren = {
  AuthTagsSlugRoute: AuthTagsSlugRoute,
}

const AuthTagsRouteWithChildren = AuthTagsRoute._addFileChildren(
  AuthTagsRouteChildren,
)

interface AuthRouteChildren {
  AuthDeliveriesRoute: typeof AuthDeliveriesRouteWithChildren
  AuthPhotosRoute: typeof AuthPhotosRouteWithChildren
  AuthSessionsRoute: typeof AuthSessionsRouteWithChildren
  AuthTagsRoute: typeof AuthTagsRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthDeliveriesRoute: AuthDeliveriesRouteWithChildren,
  AuthPhotosRoute: AuthPhotosRouteWithChildren,
  AuthSessionsRoute: AuthSessionsRouteWithChildren,
  AuthTagsRoute: AuthTagsRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
